export default __webpack_public_path__ + "static/media/streak.e808d6b4.svg";